module.exports = __webpack_public_path__ + "static/media/arrow_left.270f72df.svg";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/themes/src/libs/mdbootstrap/img/svg/arrow_left.svg
// module id = 1471
// module chunks = 0